import { render, staticRenderFns } from "./AuditPendenciesServices.vue?vue&type=template&id=6871395e&scoped=true"
import script from "./AuditPendenciesServices.vue?vue&type=script&lang=js"
export * from "./AuditPendenciesServices.vue?vue&type=script&lang=js"
import style0 from "./AuditPendenciesServices.vue?vue&type=style&index=0&id=6871395e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871395e",
  null
  
)

export default component.exports